const GRID_CLASS_WITH_SELECTION =
  "grid-cols-[36px_minmax(180px,1.8fr)_28px_minmax(260px,2.6fr)_minmax(120px,1fr)_56px]";

const GRID_CLASS_WITHOUT_SELECTION =
  "grid-cols-[minmax(180px,1.8fr)_28px_minmax(260px,2.6fr)_minmax(120px,1fr)_56px]";

// Approved/Rejected sections drop the Confidence column: settled rows carry
// only their action button, which needs the wider last track.
const GRID_CLASS_WITH_SELECTION_NO_CONFIDENCE =
  "grid-cols-[36px_minmax(180px,1.8fr)_28px_minmax(260px,2.6fr)_minmax(130px,auto)]";

const GRID_CLASS_WITHOUT_SELECTION_NO_CONFIDENCE =
  "grid-cols-[minmax(180px,1.8fr)_28px_minmax(260px,2.6fr)_minmax(130px,auto)]";

export function getAttributeReviewGridClass(
  showSelection: boolean,
  showConfidence = true,
): string {
  if (!showConfidence) {
    return showSelection
      ? GRID_CLASS_WITH_SELECTION_NO_CONFIDENCE
      : GRID_CLASS_WITHOUT_SELECTION_NO_CONFIDENCE;
  }
  return showSelection
    ? GRID_CLASS_WITH_SELECTION
    : GRID_CLASS_WITHOUT_SELECTION;
}
